import BuybackClient from "@/apps/shared/buyback/core/infrastructure/client/buybackClient";
import { BuybackSettings } from "@/apps/shared/buyback/core/domain/model/settings/BuybackSettings";
import BuybackSettingsMapper from "@/apps/shared/buyback/core/infrastructure/mapper/buyback/settings/buybackSettingsMapper";
import { BuybackSettingsRepositoryInterface } from "@/apps/shared/buyback/core/domain/service/interface/BuybackSettingsRepositoryInterface";

class WhiteLabelBuybackSettingsRepository implements BuybackSettingsRepositoryInterface {
  async get(): Promise<BuybackSettings> {
    const settingsData = await BuybackClient.getBuybackSettings();

    return BuybackSettingsMapper.mapBuybackSettingsFromResponse(settingsData);
  }
}

export default new WhiteLabelBuybackSettingsRepository();
